import { render, staticRenderFns } from "./EditBulletin.vue?vue&type=template&id=575b5a1b&scoped=true&"
import script from "./EditBulletin.vue?vue&type=script&lang=js&"
export * from "./EditBulletin.vue?vue&type=script&lang=js&"
import style0 from "./EditBulletin.vue?vue&type=style&index=0&id=575b5a1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575b5a1b",
  null
  
)

export default component.exports